import { Link } from "react-router-dom";

export function Navigation() {
  return <footer className="navigation">
      <Link to="/">Termin vereinbaren</Link> &bull; <Link to="/testablauf">Testablauf &amp; Infos</Link> &bull; <Link to="/impressum">Impressum</Link> &bull; <Link to="/datenschutz">Datenschutz</Link>
  </footer>;
}
